import React, { Component, useState } from "react";
import "../Styles/AskModal.css";

export const ConfirmCode = ({ phoneNumber, confirm, close, performance }) => {
  const [code, setCode] = useState("");
  return (
    <div className="AskContainer" style={{position: "fixed"}}>
      <div className="card AskCard" style={{borderRadius:"4px"}}>
        <div className="card-body">
          <input
            className="form-control"
            type="tel"
            onChange={(e) => setCode(e.target.value)}
            inputMode="numeric"
            pattern="[0-9\s]{13,19}"
            maxLength={6}
            placeholder="Código"
          ></input>
        </div>
        <div
          className="card-footer"
          style={{ background: "#fff", borderTop: "0px" }}
        >
          <div className="AskFooter">
          <button
              className="AskBtn"
              onClick={() => close()}
            >
             {performance ? "Cerrar" : "Otro método"}
            </button>
            <button
              className="AskBtn"
              disabled={code.length < 6}
              onClick={() => confirm(phoneNumber, code)}
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
  
};
